import { normalizeFormAggregationRow } from '../FormAggregationRow';
import { normalizeTableRowEntity } from '../TableRow';
import { FormAggregationResponseApi } from '../endpoints/form.aggregation_get';

import { FormAggregationEntity } from './entity';

export const normalizeFormAggregation = (
  raw: FormAggregationResponseApi
): FormAggregationEntity => {
  return {
    aggregationRow: raw.aggregation_row?.map((chunk) =>
      normalizeFormAggregationRow(chunk)
    ),
    footerRow: raw.footer_row && normalizeTableRowEntity(raw.footer_row),
  };
};
